module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/clan_quests_top_big.5d598a32.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/clan_quests_top_big.png
// module id = 2961
// module chunks = 11